module.exports = __webpack_public_path__ + "static/media/wema.38170c72.svg";